import "../App.css";
import FirstScreen from "../screens/FirstScreen";
import FourthScreen from "../screens/FourthScreen";
import Header from "../screens/Header";
import SecondScreen from "../screens/SecondScreen";
import ThirdScreen from "../screens/ThirdScreen";
import SixthScreen from "../screens/SixthScreen";
import SeventhScreen from "../screens/SeventhScreen";
import Footer from "../screens/Footer";
import Modal from "../screens/Modal";
import ScrollUpBtn from "../components/ScrollUpBtn";

function MainPage() {
  return (
    <div className="App">
      <Header />
      <FirstScreen />
      <SecondScreen />
      <ThirdScreen />
      <FourthScreen />
      {/* <FifthScreen /> */}
      <SixthScreen />
      <SeventhScreen />
      <Footer />
      <Modal />
      <ScrollUpBtn />
    </div>
  );
}

export default MainPage;
